import { useState } from 'react';
import { Dumbbell, Zap, Trophy, Activity } from 'lucide-react';
import { SessionEditor } from '@/components/SessionEditor';

const TILES = [
  { type: 'Strength Training', label: 'Strength', sub: 'Custom resistance training', icon: Dumbbell, color: '#00C8FF', id: 'strength' },
  { type: 'HIIT', label: 'HIIT', sub: 'Intervals and circuits', icon: Zap, color: '#F59E0B', id: 'hiit' },
  { type: 'Fitness Racing', label: 'Fitness Racing', sub: 'HYROX-style or race preparation', icon: Trophy, color: '#16A34A', id: 'fitness-racing' },
  { type: 'other', label: 'Other Activity', sub: 'Running, badminton, cycling, etc.', icon: Activity, color: '#8B5CF6', id: 'other' },
];

export function AddWorkoutPicker({ onOther, onSaved, defaultDate }) {
  const [buildType, setBuildType] = useState(null);
  return (
    <div className="regen-card-elevated p-5" data-testid="add-workout-picker">
      <div className="font-display font-bold text-lg">Add an activity or workout</div>
      <p className="text-xs text-muted-foreground mt-1">Extra training on top of your plan — it never replaces your prescribed sessions.</p>
      <div className="grid grid-cols-2 gap-3 mt-4">
        {TILES.map(t => (
          <button key={t.id} onClick={() => (t.type === 'other' ? onOther?.() : setBuildType(t.type))} data-testid={`add-workout-${t.id}`}
            className="rounded-2xl border border-[var(--c-hair)] p-4 text-center hover:bg-[var(--c-film)] active:scale-[0.98] transition-transform">
            <t.icon className="w-6 h-6 mx-auto" style={{ color: t.color }} />
            <div className="font-display font-bold text-sm mt-2">{t.label}</div>
            <div className="text-[11px] text-muted-foreground mt-0.5 leading-snug">{t.sub}</div>
          </button>
        ))}
      </div>
      <SessionEditor open={!!buildType} onOpenChange={(o) => !o && setBuildType(null)} mode="build" buildType={buildType || 'Strength Training'} defaultDate={defaultDate} onSaved={onSaved} />
    </div>
  );
}
